document.addEventListener('DOMContentLoaded', function() {
  const quickLinks = document.querySelectorAll('.mobile-quick-links__item');
  
  quickLinks.forEach(function(link) {
    link.addEventListener('touchstart', function() {
      this.style.opacity = '0.7';
    });
    
    link.addEventListener('touchend', function() {
      this.style.opacity = '1';
    });
    
    link.addEventListener('touchcancel', function() {
      this.style.opacity = '1';
    });
    
    if (link.classList.contains('mobile-quick-links__trigger')) {
      const triggerType = link.getAttribute('data-trigger');
      
      if (triggerType === 'cart') {
        link.addEventListener('click', function(e) {
          e.preventDefault();
          const cartDrawer = document.querySelector('cart-drawer');
          if (cartDrawer && typeof cartDrawer.open === 'function') {
            cartDrawer.open();
          } else {
            const targetClass = this.getAttribute('data-target-class');
            const cartTrigger = document.querySelector(targetClass || '.cart-drawer-trigger');
            if (cartTrigger) {
              cartTrigger.click();
            }
          }
        });
      }

      if (triggerType === 'menu') {
        link.addEventListener('click', function(e) {
          e.preventDefault();
          const menuTrigger = document.querySelector('header-drawer, .mobile-nav-trigger, [aria-controls="mobile-menu"]');
          if (menuTrigger && typeof menuTrigger.open === 'function') {
             menuTrigger.open();
          } else if (menuTrigger) {
            menuTrigger.click();
          }
        });
      }
    }
  });

  const observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      if (mutation.type === 'childList') {
        const cartDrawer = document.querySelector('cart-drawer');
        if (cartDrawer && !cartDrawer.hasAttribute('data-mobile-quick-links-ready')) {
          cartDrawer.setAttribute('data-mobile-quick-links-ready', 'true');
        }
      }
    });
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
});
